import styled, {keyframes} from 'styled-components';
import breakpoint from '../../../theme/constants/breakpoints';
import zIndex from '../../../theme/constants/zIndex';
import pxToRem from '../../../theme/helpers/pxToRem';
import Typography from '../../../theme/typography';
import {StyledProps} from './typings';

const show = keyframes`
from {
  opacity: 0;
  transform: translate3d(0, -35px, 0);
}

to {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}
`;

const hide = keyframes`
from {
  opacity: 1;
}
    
to {
  opacity: 0;
}
`;

const animationSpeed = 0.2;

const StyledCtaSticky = styled.div<StyledProps>`
  position: fixed;
  top: 0;
  z-index: ${zIndex.fixed};
  height: 78px;
  width: 100vw;
  display: ${(props) => props.$displayStyle};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #fff;
  box-shadow: 0 0 13px rgba(0, 0, 0, 0.33);
  transform: translate3d(0, -35px, 0);
  animation: ${(props) => (props.$show ? show : hide)} ${animationSpeed}s linear;
  transform: translate3d(0, ${(props) => (props.$show ? '0' : '-35px')}, 0);
  transition: transform ${animationSpeed}s linear;

  button {
    min-width: 100px;
    line-height: ${pxToRem(17)};
    white-space: normal;
    flex-shrink: 10000;
  }

  section {
    margin-right: auto;
    padding-right: 10px;
  }

  figure {
    flex-shrink: 0;
    border-radius: 4px;
    margin-right: 10px;
  }

  @media only screen and ${breakpoint.device.s} {
    display: none;
  }
`;

export const StyledTitle = styled.p`
  ${Typography.Body2}
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const StyledPrice = styled.p`
  ${Typography.Art}
`;

export default StyledCtaSticky;
